<template>
  <div
    id="tab-profile"
    class="tab-profile"
  >
    <div class="tab-profile-content">
      <div class="profile-rating">
        <div v-if="userLogged">
          <div
            class="tab-profile-top"
            :class="{
              light: isLightTheme,
              dark: !isLightTheme,
            }"
          >
            <div class="profile-avatar">
              <aha-avatar
                :name="`${$store.state.currentUser.firstName} ${$store.state.currentUser.lastName}`"
                :image="$store.state.currentUser.avatar"
                :id="$store.state.currentUser.id"
                :width="40"
                :height="40"
                class="mr-2 text-lg"
              />
            </div>
            <div class="profile-info">
              <div class="profile-info__name">
                {{ $store.state.currentUser.firstName }}
              </div>
              <div class="profile-info__email">
                {{ $store.state.currentUser.email }}
              </div>
            </div>
          </div>
          <div
            class="profile-logout"
            :class="{
              light: isLightTheme,
              dark: !isLightTheme,
            }"
          />
        </div>
        <google-button-profile type="login" v-else>
          Log in to save your info
        </google-button-profile>
        <div
          class="sidebar__container"
          :class="{
            light: isLightTheme,
            dark: !isLightTheme,
          }"
        >
          <div class="sidebar__item" @click="openHref('https://ahaslides.com/blog/ahaslides-tutorials/?source=audience_home&medium=audience_app&campaign=tutorials')">
            <aha-svg
              name="profile_tutorial"
              width="20"
              height="20"
            />
            <span class="sidebar__item-name">Tutorials</span>
          </div>
          <div class="sidebar__item" @click="openHref('https://ahaslides.com/terms/?source=audience_home&medium=audience_app&campaign=terms')">
            <aha-svg
              name="profile_terms"
              width="20"
              height="20"
            />
            <span class="sidebar__item-name">Terms</span>
          </div>
          <div class="sidebar__item" @click="openHref('https://ahaslides.com/?source=audience_home&medium=audience_app&campaign=powered_by')">
            <aha-svg
              name="profile_info"
              width="20"
              height="20"
            />
            <span class="sidebar__item-name">About AhaSlides</span>
          </div>
          <div class="sidebar__item" @click="handleLogoutButtonClick" v-if="userLogged">
            <aha-svg
              name="profile_logout"
              width="20"
              height="20"
            />
            <span class="sidebar__item-name">Log out</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import GoogleButtonProfile from '@/components/common/GoogleButtonProfile.vue'
import util from '@/util'
import cookie from '@/services/cookie'

export default {
  components: {
    GoogleButtonProfile,
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
      textColour: (state) => state.slide.textColour,
      currentUser: (state) => state.currentUser,
    }),
    userLogged() {
      return this.currentUser && this.currentUser.id
    },
    isLightTheme() {
      return this.$store.state.slide.textColour === '#313131'
    },
  },
  methods: {
    ...mapActions(['setCurrentUserAction']),
    openHref(url) {
      if (window) {
        const windowsOpen = window.open(url, '_blank')
        if (windowsOpen) {
          windowsOpen.focus()
        }
      }
    },
    handleLogoutButtonClick() {
      util.setCookieToken('')
      util.removeTokenCookie()
      cookie.deleteValue('ahaAudienceToken')
      this.setCurrentUserAction({})
      if (this.presentation) {
        localStorage.removeItem(`aha-presentation-${this.presentation.id}`)
      }
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.tab-profile {
  input[type='text'] {
    height: 40px;
    border: none;
    background-color: #fff;
    padding-right: 8px;
    min-width: 50px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .button-submit {
    width: 90px;
    font-size: 14px;
    text-transform: capitalize;
    padding: 0;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    border-radius: 20px;
    background-color: $brand-a100;

    i {
      font-size: 14px;
    }
    .loading-spinner {
      margin-left: 4.5px;
      width: 1.2em;
      height: 1.2em;
    }
  }
}

.profile-rating {
  margin: 0 auto;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  max-width: 600px;
}

.tab-profile-top {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  &.light {
    background: rgba(221, 236, 255, 1);
  }

  &.dark {
    background: rgba(255, 255, 255, 0.1);

  }
}

.profile-avatar {
  margin-right: 0.75rem;
}

.profile-info{
  line-height: 1.25rem;
  .profile-info__name {
    font-weight: 700;
  }
  .profile-info__email {
    font-size: 0.9rem;
    line-height: 1rem;
  }
}

.profile-logout{
  cursor: pointer;
  line-height: 3.5rem;
  white-space: nowrap;
  --tw-text-opacity: 1;
  color: rgba(75, 75, 75, var(--tw-text-opacity));
  svg.path-fill-current.inline-block {
    margin-right: 0.5rem;
    display: inline-block;
    vertical-align: middle;
    color: rgb(153, 153, 153);
  }
  &.dark{
    color: #FFFFFF;
    svg.path-fill-current.inline-block{
      color: #FFFFFF;
    }
  }
}

.sidebar__container {
  &.light{
    .sidebar__item {
      &:hover {
        background-color: rgba(245, 245, 245, 1);
        cursor: pointer;

      }
    }
  }

  &.dark{
    .sidebar__item {
      &:hover {
        background-color: rgba(255, 255, 255, 0.05);
        cursor: pointer;
        color: rgba(255, 255, 255, 1);

      }
    }
  }

  margin-top: 15px;

  .sidebar__item {

    display: flex;
    align-items: flex-start;
    font-size: 14px;
    padding: 10px 20px 7px;

    .sidebar__item-name {
      margin-left: 5px;
    }

    svg {
      color: #999999;
    }
  }
}
</style>
